/* Enhance the existing native mobile gallery without changing product options. */
(function () {
  'use strict';
  if (window.sidizMobileProductGalleryReady) return;
  window.sidizMobileProductGalleryReady = true;

  var instances = new Map();
  var mobile = window.matchMedia('(max-width: 1023px)');
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function thumbnailSource(value) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.href);
      if (url.hostname === 'cdn.shopify.com' ||
          (url.origin === window.location.origin && url.pathname.indexOf('/cdn/shop/') === 0)) {
        url.searchParams.set('width', '160');
      }
      return url.href;
    } catch (error) {
      return value;
    }
  }

  function init(root) {
    if (instances.has(root)) return;
    var gallery = root.querySelector('.product-gallery.mobile');
    var track = gallery && gallery.querySelector(':scope > .swiper-wrapper');
    if (!gallery || !track) return;
    var disposed = false;
    var frame = 0;
    var enabled = false;
    var currentSlide = null;
    var records = new Map();
    var slides = [];
    var rail = document.createElement('div');
    rail.className = 'sidiz-mobile-gallery-thumbnails';
    rail.setAttribute('role', 'group');
    rail.setAttribute('aria-label', 'Product images and videos');
    rail.hidden = true;
    gallery.insertAdjacentElement('afterend', rail);

    function canEnhance() {
      return document.body.dataset.sidizMobileCommerce === 'true' && mobile.matches && !root.classList.contains('sidiz-compact-variant-gallery') &&
        !gallery.classList.contains('swiper-initialized') && !gallery.swiper;
    }

    function visibleSlides() {
      return Array.prototype.filter.call(track.children, function (slide) {
        return slide.classList.contains('product-media--item') && !slide.hidden &&
          !slide.classList.contains('hidden') && window.getComputedStyle(slide).display !== 'none';
      });
    }

    function navigate(slide, instant) {
      if (!enabled || slides.indexOf(slide) === -1) return;
      var left = gallery.scrollLeft + slide.getBoundingClientRect().left - gallery.getBoundingClientRect().left;
      gallery.scrollTo({ left: left, behavior: instant || motion.matches ? 'instant' : 'smooth' });
    }

    function updateCurrent() {
      if (!enabled || !slides.length) return;
      var edge = gallery.getBoundingClientRect().left;
      currentSlide = slides.reduce(function (nearest, slide) {
        return Math.abs(slide.getBoundingClientRect().left - edge) <
          Math.abs(nearest.getBoundingClientRect().left - edge) ? slide : nearest;
      }, slides[0]);
      records.forEach(function (record, slide) {
        record.button.setAttribute('aria-current', slide === currentSlide ? 'true' : 'false');
      });
    }

    function makeRecord(slide) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sidiz-mobile-gallery-thumbnail';
      button.addEventListener('click', function () { navigate(slide, false); });
      button.addEventListener('keydown', function (event) {
        var index = slides.indexOf(slide);
        if (event.key === 'ArrowRight') index = Math.min(slides.length - 1, index + 1);
        else if (event.key === 'ArrowLeft') index = Math.max(0, index - 1);
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = slides.length - 1;
        else return;
        event.preventDefault();
        records.get(slides[index]).button.focus({ preventScroll: true });
        navigate(slides[index], false);
      });
      var record = { button: button, source: null, label: null };
      records.set(slide, record);
      return record;
    }

    function updateRecord(slide, index) {
      var record = records.get(slide) || makeRecord(slide);
      var hero = slide.classList.contains('variant-media');
      var image = hero
        ? slide.querySelector('.variant-image.is-active:not(.hidden)') || slide.querySelector('.variant-image:not(.hidden):not(.is-exiting)')
        : slide.querySelector('img');
      var video = slide.querySelector('video');
      var source = thumbnailSource(image && (image.currentSrc || image.getAttribute('src') || image.dataset.src) || video && video.poster);
      var description = image && image.alt || video && video.getAttribute('aria-label') || '';
      var label = 'View ' + (hero ? 'selected colour' : video ? 'video' : 'image') + ' ' + (index + 1);
      if (description) label += ': ' + description;
      if (record.label !== label) {
        record.button.setAttribute('aria-label', label);
        record.button.title = label;
        record.label = label;
      }
      if (record.source !== source) {
        record.button.replaceChildren();
        if (source) {
          var thumb = document.createElement('img');
          thumb.alt = '';
          thumb.width = 56;
          thumb.height = 56;
          thumb.loading = 'lazy';
          thumb.decoding = 'async';
          thumb.src = source;
          record.button.appendChild(thumb);
        } else {
          record.button.textContent = String(index + 1);
        }
        if (video) {
          var marker = document.createElement('span');
          marker.className = 'sidiz-mobile-gallery-thumbnail__video';
          marker.setAttribute('aria-hidden', 'true');
          marker.textContent = '\u25b6';
          record.button.appendChild(marker);
        }
        record.source = source;
      }
      return record;
    }

    function reconcile() {
      frame = 0;
      if (disposed) return;
      enabled = canEnhance();
      rail.hidden = !enabled;
      if (!enabled) {
        gallery.removeAttribute('data-sidiz-mobile-gallery');
        return;
      }
      gallery.setAttribute('data-sidiz-mobile-gallery', '');
      slides = visibleSlides();
      records.forEach(function (record, slide) {
        if (slides.indexOf(slide) === -1) {
          record.button.remove();
          records.delete(slide);
        }
      });
      slides.forEach(function (slide, index) {
        var button = updateRecord(slide, index).button;
        if (rail.children[index] !== button) rail.insertBefore(button, rail.children[index] || null);
      });
      rail.hidden = slides.length < 2;
      if (currentSlide && slides.indexOf(currentSlide) === -1 && slides.length) navigate(slides[0], true);
      updateCurrent();
    }

    function schedule() {
      if (!disposed && !frame) frame = window.requestAnimationFrame(reconcile);
    }

    function onVariantSelected() {
      if (!canEnhance()) return;
      reconcile();
      var hero = slides.find(function (slide) { return slide.classList.contains('variant-media'); });
      if (hero) navigate(hero, true);
      schedule();
    }

    var observer = new MutationObserver(schedule);
    observer.observe(track, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'src', 'srcset', 'data-src', 'data-srcset', 'hidden', 'poster'] });
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    observer.observe(gallery, { attributes: true, attributeFilter: ['class'] });
    gallery.addEventListener('scroll', schedule, { passive: true });
    track.addEventListener('load', schedule, true);
    root.addEventListener('sidiz:variant-selected', onVariantSelected);
    window.addEventListener('resize', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    instances.set(root, function () {
      disposed = true;
      observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      gallery.removeEventListener('scroll', schedule);
      track.removeEventListener('load', schedule, true);
      root.removeEventListener('sidiz:variant-selected', onVariantSelected);
      window.removeEventListener('resize', schedule);
      mobile.removeEventListener('change', schedule);
      gallery.removeAttribute('data-sidiz-mobile-gallery');
      rail.remove();
      records.clear();
      instances.delete(root);
    });
    reconcile();
  }

  function boot(scope) {
    if (document.body.dataset.sidizMobileCommerce !== 'true') return;
    if (scope.matches && scope.matches('[data-sidiz-configurator]')) init(scope);
    scope.querySelectorAll('[data-sidiz-configurator]').forEach(init);
  }
  function start() {
    boot(document);
    new MutationObserver(function () {
      if (document.body.dataset.sidizMobileCommerce === 'true') boot(document);
      else instances.forEach(function (dispose) { dispose(); });
    }).observe(document.body, { attributes: true, attributeFilter: ['data-sidiz-mobile-commerce'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, root) {
      if (event.target === root || event.target.contains(root)) dispose();
    });
  });
})();
